import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/ContactHeader.css';

gsap.registerPlugin(ScrollTrigger);

const ContactHeader = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(titleRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
   <div className="pcb-header" ref={sectionRef}>
      <div className="pcb-overlay">
        <div className="pcb-content">
          <h1 className="pcb-title " ref={titleRef}>Contact US</h1>
         
        </div>
      </div>

   
      <svg className="pcb-curve" viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
          fill="#ffffff"
        />
      </svg>
    </div>
  );
};

export default ContactHeader;
